<template>
  <div class="main" id="apply">
    <van-row justify="center" v-if="classDetailsObj" style="height: 100%;">
      <div class="topTitleDiv">
        <span class="topTitleFontCss">{{ classDetailsObj.schoolName }}</span>
      </div>
      <van-col span="24" style="
      height: 93%;
      overflow: hidden;
      border-radius: 8px;
      width: 92%;
      margin-left: 4%;
      margin-top: 10px;">
        <div class="contentDivCss">
          <div class="classInformationCss">
            <img :src="classDetailsObj.teacherAvatar" v-if="classDetailsObj.teacherAvatar" class="headImgCss" />
            <img src="@/assets/img/childrenIocn.png" v-else class="headImgCss" />
            <div>
              <div>
                <span class="teacherFontCss">{{
                  classDetailsObj.teacherName
                }}</span><span style="font-size: 15px; color: #666; font-weight: 500">邀请您加入</span>
              </div>
              <div class="classNameDivCss">{{ classDetailsObj.className }}</div>
            </div>
          </div>
          <div class="parentalTipsDivCss">
            <span style="font-size: 15px; color: #333333">家长您好：</span>
            <p class="tipsContentCss">
              {{ classDetailsObj.content }}
            </p>
          </div>
          <p class="formTitleFontCss">{{status ? '加入成功' : '信息填写'}}</p>
          <div class="submitDivBtnCss" v-if="status">
            <a :href="urlScheme" class="aLabel" style="margin-top: 60px;margin-bottom: 30px;">打开小程序</a>
            <a href="https://h5.growth.bedoke.com/download.html" class="aLabel">下载APP</a>
          </div>
          <van-form validate-first @submit="onSubmit" v-else>
            <van-field readonly clickable :value="childName" label="孩子姓名：" placeholder="请选择孩子" right-icon="arrow-down"
              @click="showChildPicker = true" :rules="[{ required: true }]" :border="false" />
            <van-field v-if="childName" v-model="childIDCard" readonly label="孩子身份证：" :border="false" />
            <van-field v-if="childName" v-model="perfectIDCard" label="完善身份证：" placeholder="身份证后6位"
              :rules="perfectIDCardRules" :border="false" />
            <div style="margin-bottom: 10px">
              <p class="myFormFontCss">您是孩子的：</p>
              <div class="identityBtnDivCss">
                <van-button v-for="(item, index) in identityNameDataList" :key="index" round :class="[
                    { identitybtncssAction: identityData === item.code },
                    'identityBtnCss',
                  ]" size="small" native-type="button" @click="getParentIdentity(item.code)">{{ item.name }}
                </van-button>
                <van-button round :class="[
                    { identitybtncssAction: otherIdentityData },
                    'identityBtnCss',
                  ]" size="small" native-type="button" @click="getOtherIdentity">{{
                    otherIdentityNameData ? otherIdentityNameData : "其他"
                  }}</van-button>
              </div>
            </div>
            <van-field v-model="phoneNumberData" label="家长电话：" placeholder="手机号码" :rules="phoneNumberDataRules"
              :border="false" />
            <van-field center v-model="verificationCode" label="验证码：" placeholder="验证码" :rules="[{ required: true }]"
              use-button-slot :border="false">
              <van-button slot="button" class="codeBtnCss" round native-type="button" :disabled="!isCodeClick"
                @click="getGainCode"><span style="color: #fff; font-size: 12px; width: 100%">{{
                  timeCodeTetx
                }}</span></van-button>
            </van-field>
            <div style="margin: 20px">
              <van-button class="btnDivCss" round native-type="submit"><span
                  style="color: #fff; font-size: 16px">确认加入</span></van-button>
            </div>
          </van-form>
        </div>
        <div style="height: 10px;"></div>
      </van-col>
    </van-row>
    <van-popup v-model="showChildPicker" round position="bottom">
      <van-picker title="请选择孩子" show-toolbar :visible-item-count="4" :columns="childDataList" value-key="name"
        @confirm="onConfirmChooseChildren" @cancel="showChildPicker = false" />
    </van-popup>
    <van-popup v-model="otherIdentityIsShow" position="bottom" round :style="{ height: '30%' }">
      <div class="otherIdentityBtnDivCss">
        <van-button v-for="(item, index) in otherIdentityDataList" :key="index" round :class="[
            { otherIdentitybtncssAction: otherIdentityData === item.code },
            'otherIdentityBtnCss',
          ]" native-type="button" size="small" style="margin-left: 10px; margin-bottom: 12px"
          @click="getOtherIdentityData(item)">{{ item.name }}</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
  import {
    Toast
  } from "vant";
  import {
    parentalIdentity,
    sendVerifyCode,
    shareDetailsData,
    invitationChildrenDataList,
    phoneCodeLogin,
    bindingOfChildrenAndParents,
    bindingFriend
  } from "@/api/inviteParentsToClass/index";
  import {
    scheme
  } from '@/api/scheme/index'
  export default {
    name: "inviteParentsToClass",
    data() {
      return {
        childName: "", //孩子姓名
        childDataId: "", //孩子id
        childIDCard: "", //孩子身份证号码
        perfectIDCard: "", //完善孩子身份证号码
        identityData: "", //选中的孩子身份(父母)
        otherIdentityData: "", //选中的孩子身份(其他)
        otherIdentityNameData: "", //选中的孩子身份名称(其他)
        phoneNumberData: "", //家长的手机号码
        verificationCode: "", //验证码
        childDataList: [], //孩子数据列表
        identityNameDataList: [], //父母的身份列表
        otherIdentityDataList: [], //其他的身份列表
        showChildPicker: false,
        otherIdentityIsShow: false,
        isCodeClick: true,
        timeCodeTetx: "获取验证码",
        phoneNumberDataRules: [{
          validator: (value) => {
            return /^1[3456789]\d{9}$/.test(value);
          },
          message: "请输入正确格式的手机号码",
        }, ],
        perfectIDCardRules: [{
          validator: (value) => {
            return /^\d{5}(\d|X|x)$/.test(value);
          },
          message: "请输入孩子身份证后6位",
        }, ],
        invitationCodeStr: this.$route.query.invitationCode,
        teacherUserId: this.$route.query.teacherUserId,
        classDetailsObj: null,
        currentUserId: "", //当前用户id
        urlScheme: '', // 跳转微信小程序
        status: false,
      };
    },
    created() {
      this.onKeyboardOcclusion()
      this.getScheme()
    },
    watch: {
      phoneNumberData(newvalue, oldvalue) {
        if (newvalue !== oldvalue) {
          this.currentUserId = "";
          this.verificationCode = "";
        }
      },
    },
    mounted() {
      this.getShareDetailsData();
      this.getParentIdentityDataList();
    },
    methods: {
      // 获取URL Scheme 链接
      async getScheme() {
        const res = await scheme({
          redirectUrl: 'pages/tabBar/home/index'
        })
        if (res.errcode === 0) {
          this.urlScheme = res.openlink
        } else {
          this.urlScheme = 'https://h5.growth.bedoke.com/download.html'
        }
      },
      /* 获取分享页面详情数据 */
      async getShareDetailsData() {
        let parameter = {
          baseCode: this.invitationCodeStr,
          techerUserId: this.teacherUserId,
        };
        const res = await shareDetailsData(parameter);
        if (res.code === 200) {
          this.classDetailsObj = res.data;
          this.getInvitationChildrenDataList();
        } else {
          alert("数据错误！");
          window.location.replace("https://h5.growth.bedoke.com/download.html");
        }
      },
      /* 获取孩子数据列表 */
      async getInvitationChildrenDataList() {
        const res = await invitationChildrenDataList({
          baseCode: this.invitationCodeStr,
        });
        if (res.code === 200) {
          if (res.data.length > 0) {
            this.childDataList = res.data;
          } else {
            return Toast("该班级暂无可认领孩子！");
          }
        } else {
          return Toast("邀请码错误，请重新扫码");
        }
      },
      /* 获取家长身份列表数据 */
      async getParentIdentityDataList() {
        const res = await parentalIdentity();
        if (res.code === 200) {
          let newDataArr = res.data;
          let newIdentityArr = [];
          let newOtherIdentityArr = [];
          newDataArr.map((item) => {
            if (item.code === "MA_MA" || item.code === "BA_BA") {
              newIdentityArr.push(item);
            } else {
              newOtherIdentityArr.push(item);
            }
          });
          this.identityNameDataList = newIdentityArr;
          this.otherIdentityDataList = newOtherIdentityArr;
          this.identityData = newIdentityArr[0].code;
        } else {
          this.identityNameDataList = [];
          this.otherIdentityDataList = [];
        }
      },
      /* 确认选择孩子 */
      onConfirmChooseChildren(dataEvent) {
        this.childName = dataEvent.name;
        this.childDataId = dataEvent.babyId;
        this.childIDCard = dataEvent.cardId;
        this.showChildPicker = false;
      },
      /* 点击选中父母身份 */
      getParentIdentity(dataEvent) {
        this.identityData = dataEvent;
        this.otherIdentityData = "";
        this.otherIdentityNameData = "";
        this.otherIdentityIsShow = false;
      },
      /* 点击其他身份 */
      getOtherIdentity() {
        this.otherIdentityIsShow = true;
      },
      /* 点击选中其他身份数据 */
      getOtherIdentityData(dataEvent) {
        this.otherIdentityIsShow = false;
        this.identityData = "";
        this.otherIdentityData = dataEvent.code;
        this.otherIdentityNameData = dataEvent.name;
      },
      /* 点击获取验证码 */
      async getGainCode() {
        if (this.isCodeClick) {
          if (/^1[3456789]\d{9}$/.test(this.phoneNumberData)) {
            const res = await sendVerifyCode({
              mobile: this.phoneNumberData
            }); // 获取验证码接口
            if (res.code === 200) {
              Toast.success("验证码发送成功");
              this.isCodeClick = false;
              let s = 60;
              this.timeCodeTetx = s + "s";
              let interval = setInterval(() => {
                s--;
                this.timeCodeTetx = s + "s";
                if (s < 0) {
                  this.timeCodeTetx = "重新获取";
                  this.isCodeClick = true;
                  clearInterval(interval);
                }
              }, 1000);
            }
          } else {
            Toast.fail("请输入正确的手机号码");
          }
        }
      },
      async onSubmit() {
        /* 判断是否已注册登录 */
        if (!this.currentUserId) {
          /* 先执行注册登录功能 */
          let parameter = {
            mobile: this.phoneNumberData,
            checkCode: this.verificationCode,
          };
          const res = await phoneCodeLogin(parameter);
          if (res.code !== 200 || res.token === null) {
            Toast.fail(res.msg, 2000, "center");
            return;
          }
          this.currentUserId = res.userId;
        }
        /* 执行孩子与家长绑定功能 */
        this.getBindingOfChildrenAndParents();
        this.getBindingFriend()
      },
      async getBindingOfChildrenAndParents() {
        let parameter = {
          baseCode: this.invitationCodeStr,
          childId: this.childDataId,
          babyIdentification: this.identityData ?
            this.identityData : this.otherIdentityData,
          idCardLast6: this.perfectIDCard,
          userId: this.currentUserId,
          teacherUserId: this.teacherUserId * 1,
        };
        const res = await bindingOfChildrenAndParents(parameter);
        if (res.code === 200) {
          Toast("操作成功");
          this.status = true
        } else {
          this.status = false
          Toast(res.msg || "绑定失败，请重试");
        }
      },
      getBindingFriend() {
        let parameter = {
          teacherUserId: this.teacherUserId,
          userId: this.currentUserId
        }
        bindingFriend(parameter)
      },

      /* 处理浏览器键盘遮挡表单 */
      onKeyboardOcclusion() {
        var clientHeight =
          document.documentElement.clientHeight || document.body.clientHeight;
        window.onresize = function () {
          var nowClientHeight =
            document.documentElement.clientHeight || document.body.clientHeight;
          if (clientHeight - nowClientHeight > 60) {
            //因为ios有自带的底部高度
            //键盘弹出的事件处理
            document.getElementById("apply").classList.add("focusState");
          } else {
            //键盘收起的事件处理
            document.getElementById("apply").classList.remove("focusState");
          }
        };
      },
    },
    components: {},
  };
</script>
<style lang="less" scope>
  .main {
    position: fixed;
    overflow: scroll;
    width: 100%;
    height: 100%;
    background: #fc7701;
  }

  .topTitleDiv {
    margin-top: 5px;
  }

  .topTitleFontCss {
    font-size: 16px;
    font-weight: 500;
    color: #ffffff;
  }

  .contentDivCss {
    background: #fff;
    box-shadow: 0px 3px 10px 0px rgb(204 204 204 / 20%);
    height: 100%;
    overflow: scroll;
    padding: 5px 10px;
  }

  .headImgCss {
    width: 50px;
    height: 50px;
    border-radius: 100%;
    margin-right: 12px;
  }

  .classInformationCss {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .teacherFontCss {
    font-size: 15px;
    color: #000;
    font-weight: bold;
    margin-right: 10px;
  }

  .classNameDivCss {
    text-align: left;
    margin-top: 13px;
    font-size: 15px;
    font-weight: 500;
    color: #fc7701;
  }

  .parentalTipsDivCss {
    margin-top: 18px;
    text-align: left;
  }

  .tipsContentCss {
    margin-top: 10px;
    font-size: 15px;
    color: #333333;
    text-indent: 2em;
  }

  .formTitleFontCss {
    margin-top: 24px;
    margin-bottom: 10px;
    font-size: 18px;
    font-weight: bold;
    color: #000000;
  }

  .van-cell {
    padding-left: 0;
    padding-right: 0;
    border-bottom: 1px solid #ebedf0;
    margin-bottom: 10px;
  }

  .van-field__label {
    color: #333333;
    font-size: 15px;
    font-weight: 500;
  }

  .myFormFontCss {
    margin: 0 0 8px 0;
    text-align: left;
    color: #333333;
    font-size: 15px;
  }

  .identityBtnDivCss {
    display: flex;
    justify-content: space-between;
  }

  .otherIdentityBtnDivCss {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin: 20px 10px;
  }

  .identityBtnCss {
    width: 90px;
    height: 30px;
    background: #f3f3f5;
    border: 1px solid #f3f3f5;
    border-radius: 15px;
  }

  .identitybtncssAction {
    width: 90px;
    height: 30px;
    background: #fdf7e7;
    color: #fd7a01;
    border: 1px solid #fd7a01;
  }

  .otherIdentityBtnCss {
    height: 30px;
    padding: 0 15px;
    background: #f3f3f5;
    border: 1px solid #f3f3f5;
    border-radius: 15px;
  }

  .otherIdentitybtncssAction {
    height: 30px;
    padding: 0 15px;
    background: #fdf7e7;
    color: #fd7a01;
    border: 1px solid #fd7a01;
  }

  .codeBtnCss {
    width: 82px;
    height: 32px;
    padding: 0;
    background: #fc7701;
    border-radius: 5px;
  }

  .btnDivCss {
    width: 260px;
    height: 45px;
    background: linear-gradient(0deg, #f85700, #fd7c01);
    box-shadow: 0px 8px 29px 1px rgba(255, 117, 7, 0.3);
    border-radius: 45px;
  }

  .focusState {
    position: absolute;
  }

  .submitDivBtnCss {
    width: 100%;
    margin: 25px 0;
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  .aLabel {
    width: 280px;
    height: 40px;
    border: none;
    color: #fff;
    font-weight: 500;
    font-size: 16px;
    background: linear-gradient(90deg, #f85700, #ff931e);
    box-shadow: 0px 3px 10px 0px rgba(255, 117, 7, 0.5);
    border-radius: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>